/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Browser_Extensions_TitleInputs */

const en_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser Extensions`)
};

const ar_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافات المتصفح`)
};

const bn_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ব্রাউজার এক্সটেনশন`)
};

const de_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browsererweiterungen`)
};

const es_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensiones del navegador`)
};

const fr_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensions de navigateur`)
};

const pt_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensões do navegador`)
};

const zh_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器扩展`)
};

const tr_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarayıcı Uzantıları`)
};

const ru_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширения браузера`)
};

const pl_svc_browser_extensions_title = /** @type {(inputs: Svc_Browser_Extensions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozszerzenia przeglądarki`)
};

/**
* | output |
* | --- |
* | "Browser Extensions" |
*
* @param {Svc_Browser_Extensions_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_browser_extensions_title = /** @type {((inputs?: Svc_Browser_Extensions_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Browser_Extensions_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_browser_extensions_title(inputs)
	if (locale === "bn") return bn_svc_browser_extensions_title(inputs)
	if (locale === "de") return de_svc_browser_extensions_title(inputs)
	if (locale === "es") return es_svc_browser_extensions_title(inputs)
	if (locale === "fr") return fr_svc_browser_extensions_title(inputs)
	if (locale === "pt") return pt_svc_browser_extensions_title(inputs)
	if (locale === "zh") return zh_svc_browser_extensions_title(inputs)
	if (locale === "tr") return tr_svc_browser_extensions_title(inputs)
	if (locale === "ru") return ru_svc_browser_extensions_title(inputs)
	if (locale === "pl") return pl_svc_browser_extensions_title(inputs)
	return en_svc_browser_extensions_title(inputs)
});
export { svc_browser_extensions_title as "svc_browser-extensions_title" }